import React, { KeyboardEvent } from 'react';
import { Form, Space, Input, Image } from 'antd';

interface Props {
    searchString: string;
    placeholder?: string;
    changeSearch: (value: string) => void;
    cleanFilter: () => void;
    handleSearchSubmit: (e: KeyboardEvent<HTMLInputElement>) => void;
}

const TagsSearch: React.FC<Props> = ({ searchString, placeholder, changeSearch, cleanFilter, handleSearchSubmit }) => {
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        changeSearch(e.target.value);
    };

    return (
        <Form>
            <Space>
                <Input
                    placeholder={placeholder || "Tag name"}
                    onPressEnter={handleSearchSubmit}
                    onChange={handleSearchChange}
                    value={searchString}
                    id="table-search-input"
                    style={{width: 220 + `px`}}
                    prefix={
                        <>
                            {!searchString && (
                                <Image
                                    src="src/assets/images/magnifying-glass.svg"
                                    preview={false}
                                />
                            )}
                        </>
                    }
                    suffix={
                        <>
                            {searchString && (
                                <Image
                                    preview={false}
                                    src="src/assets/images/close-circle-icon.svg"
                                    onClick={cleanFilter}
                                />
                            )}
                        </>
                    }
                />
            </Space>
        </Form>
    );
};

export default TagsSearch;
